import React, { useEffect } from 'react'
import { LandingPageLayoutAndForm } from 'components/SportsbookForm'
import Head from 'components/Head'

import { usePageView } from 'hooks'
import { getStaticWrapper } from 'utils'
import pennData from 'lib/penn-analytics'

const SportsbookFormLandingPage = () => {
  usePageView()
  useEffect(() => {
    pennData.init()
  }, [])
  return (
    <>
      <Head
        noAutoZoom
        title='Barstool Sportsbook - Best Sports Betting App - Coming Soon'
        ogImage='/static/images/sportsbook/ogimage-prelaunch.png'
        description='Barstool Sportsbook is coming soon to be your home for betting on the NFL, NBA, MLB, NHL, NCAA and more. Stay connected and be the first to know about all the things coming to Barstool Sportsbook.'
      />
      <LandingPageLayoutAndForm />
    </>
  )
}

export const getStaticProps = getStaticWrapper()

export default SportsbookFormLandingPage
